import React from 'react';
import { Button, ButtonProps } from "tea-component";
import classNames from "classnames";
import './index.scss';


const PlusButton = (props: ButtonProps) => {
  const { title, className, ...restProps } = props;
  return (<Button
    type={'link'}
    className={classNames('dbl-plus-button', className)}
    {...restProps}
  >
    <span>+</span> <div>{title}</div>
  </Button>);
};


export default PlusButton;